import { render, staticRenderFns } from "./CollabListRoleChanged.vue?vue&type=template&id=19f71bc8&scoped=true&"
import script from "./CollabListRoleChanged.vue?vue&type=script&lang=js&"
export * from "./CollabListRoleChanged.vue?vue&type=script&lang=js&"
import style0 from "./CollabListRoleChanged.vue?vue&type=style&index=0&id=19f71bc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f71bc8",
  null
  
)

export default component.exports